import Interieur from "./Interieur";
import Brett from "./Brett";
import Measurer from "../interaction/Measurer";
import Bohrlochleiste from "./Bohrlochleiste";

export default class Einlegeboden extends Interieur {

    // persistent (UserLayer) ------------------------------------------

    faecherAnzahl = 1;

    isDropped = false;

    // transient (CompiledLayer) ---------------------------------------

    brett: Brett;
    meine: Einlegeboden[] = [];

    constructor(type,element) {
        super(type,element);
    }

    fromJSON(json) {
        super.fromJSON(json);
        this.faecherAnzahl = json.faecherAnzahl || 1;
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.faecherAnzahl = this.faecherAnzahl;
        return json
    }

    copy(einlegeboden,createInterceptor) {
        super.copy(einlegeboden,createInterceptor);
        einlegeboden.faecherAnzahl = einlegeboden.faecherAnzahl;
        // this._copied = true;
        return this;
    }

    compileSizeAndBox() {
        super.compileSizeAndBox();
        this.size.y = this.product.Art === null ? APP.settings.getFloat('brett_staerke') : this.product.Art / 10;
    }

    compileInternals() {
        super.compileInternals();
        if (!this.brett) {
            this.brett = new Brett(this, 'Einlegeboden', 'xz');
            this.brett.inSketch = false;
            this.brett.isInner = true;;
        }
        this.brett.box = this.boxLocal.clone();
        this.brett.box.max.z -= APP.settings.getFloat('aussenwand_vorsprung');
        this.brett.boxToVertices();
        this.brett.compile();
    }

    clone() {
        const b = new Einlegeboden(this.type,this.element);
        b.product = this.product;
        this.meine.push(b);
        return b;
    }


    setFromProduct(product) {
        this.product = product;
        this.meine.forEach(b => b.setFromProduct(product));
    }

    spreadEquallyOverFreeSpaceY() {

        const fit = new Measurer(Measurer.CENTER).getSurroundingInterieurYFit(this);
        const bohrlochleiste = Bohrlochleiste.createBohrlochleiste(this.element,this.bohrlochleiste);
        const bohrlochYs = bohrlochleiste.getBohrlochYSchrankPositions();
        const yAlloweds = bohrlochYs.filter(y=>fit && fit.contains(y));

        const mindesthoehe = bohrlochleiste.cfg.mindesthoehe_oben + bohrlochleiste.cfg.mindesthoehe_unten;
        const maxCount = Math.max(1, Math.ceil((_.last(yAlloweds) - _.first(yAlloweds)) / mindesthoehe));

        const getYPositions = choiceCount => {

            const fach_hoehe = APP.settings.getMinValue('fach_hoehe');

            // Der Measurer kalkuliert eine freie Fachhöhe ein.
            // Die soll bei der Verteilung von Einlegeböden aber "vereinnahmt" werden.
            const minY = fit.min - fach_hoehe;
            const maxY = fit.max + fach_hoehe;

            const yInterval = (maxY - minY) / (choiceCount+1);
            return _.range(choiceCount).map(i =>
                _.minBy(yAlloweds,y=>Math.abs(y- (minY + (i+1)*yInterval)))
            )

        }

        const clear = () => {
            this.meine.forEach(b => b.removeFromElement());
            this.meine = [];
        }

        const create = choiceCount => {
            clear();
            const ys = getYPositions(choiceCount);
            this.setSchrankPositionY(ys.pop());
            ys.forEach(y=>{
                const b = this.clone();
                b.addToElement(this.element);
                b.isDropped = true;
                b.setSchrankPositionY(y);
            });
        }



        return {
            maxCount,
            create
        };

    }

    /**
     * kann der Einlegeboden nur an der vorgegebenen Position stehen (weil er zur Dachschräge auf Maß geschnitten wurde)?
     */
    isFixed() {
        return this.element ? Math.abs(this.size.z-this.element.size.z)>0.01 : false;
    }

    iterate(iterator) {
        super.iterate(iterator);
        iterator(this.brett);
        this.meine.forEach(x=>x.iterate(iterator));
    }

}


